import { kebabCase } from "lodash";

export const getTagUrl = (tag: string) => {
  return `/blog/tags/${kebabCase(tag)}`;
};

